var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"licenses"}},[_c('Datatable',{ref:"datatable",attrs:{"entity":"license","globalActions":[
      {text: 'create', method: _vm.onRowCreate}
    ],"rowActions":[
      {text: 'datatable.edit', method: _vm.onRowEdit},
      {text: 'datatable.delete', method: _vm.onRowDelete}
    ]}}),_c('Panel',{staticStyle:{"margin-top":"50px"},attrs:{"title":_vm.license.id ?  (_vm.$t('licensing.edit') + ` ${_vm.license.id}`) : _vm.$t('licensing.new')}},[_c('LicenseForm',{model:{value:(_vm.license),callback:function ($$v) {_vm.license=$$v},expression:"license"}})],1),_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.saveLicense}},[_vm._v(_vm._s(_vm.$t('save')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }